import { useWSModalCustom, WSModal } from "@wingspanhq/fe-component-library";
import { WSModalCustomProps } from "@wingspanhq/fe-component-library/dist/lib/components/WSModal/useWSModalCustom.hook";
import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import { ResourceHistory } from "../../../../shared/components/ResourceHistory";

const useRequirementDefinitionHistoryResources = (
  requirementDefinitionId: string
): AuditLogResource[] => {
  return useMemo(
    () => [
      {
        resourceType:
          ListAuditLogsFilterParameterResourceTypeEq.REQUIREMENT_DEFINITION,
        resourceId: requirementDefinitionId
      }
    ],
    [requirementDefinitionId]
  );
};

type ModalProps = WSModalCustomProps<void> & {
  requirementDefinitionId: string;
};

export const ModalRequirementDefinitionHistory: React.FC<ModalProps> = ({
  requirementDefinitionId,
  ...modalProps
}) => {
  const scope = useRequirementDefinitionHistoryResources(
    requirementDefinitionId
  );

  return (
    <WSModal title="Requirement history" {...modalProps}>
      <ResourceHistory resources={scope} />
    </WSModal>
  );
};

export const RequirementDefinitionHistoryWidget: React.FC<{
  requirementDefinitionId: string;
}> = ({ requirementDefinitionId }) => {
  const modal = useWSModalCustom(ModalRequirementDefinitionHistory);
  const scope = useRequirementDefinitionHistoryResources(
    requirementDefinitionId
  );

  return (
    <ResourceHistory
      resources={scope}
      onViewAll={() => {
        modal.open({ requirementDefinitionId });
      }}
    />
  );
};
